import { render, staticRenderFns } from "./otherRkAction.vue?vue&type=template&id=1f8071e1&scoped=true"
import script from "./otherRkAction.vue?vue&type=script&lang=js"
export * from "./otherRkAction.vue?vue&type=script&lang=js"
import style0 from "./otherRkAction.vue?vue&type=style&index=0&id=1f8071e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8071e1",
  null
  
)

export default component.exports